import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useClickableTypography = makeStyles()(({ palette, spacing }: Theme) => ({
  wrapper: {
    marginBottom: spacing(5),
  },
  text: {
    fontWeight: 'bold',
    color: palette.proceed.main,

    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}));
